






































































import VueOptions from '@utils/VueOptions'
import WizardNavigation from '@ui/SpaceWizards/SpaceCreateWizard/WizardNavigation'

settings =
  name: 'SpaceOverviewStep'

  vue:
    props: ['wizard', 'step']

    components: {
      WizardNavigation,
    }

    data: ->
      form: @wizard.spaceData

    methods:
      hiSelectProductSamplingSpace: ->
        @form.type = 'product_sampling'
        @form.segment = 'Product Placement'
        @form.size = null
        @form.price_in_cents = null
        @scrollToTutorial()

      hiSelectOnsiteSpace: ->
        @form.type = 'onsite_space'
        @form.segment = 'Onsite'
        @form.size = '10x10'
        @form.price_in_cents = 50000
        @scrollToTutorial()

      scrollToTutorial: ->
        setTimeout(() =>
          @scrollContainerTo '#dashboard', '.tutorial-section'
        , 100)

export default VueOptions.vue settings
